import React from 'react';
import PropTypes from 'prop-types';
import { Card as MuiCard, styled } from '@mui/material';

// Styled Card component
const StyledCard = styled(MuiCard, {
  shouldForwardProp: (prop) => prop !== 'clickable',
})(({ theme, clickable, elevation = 1 }) => ({
  borderRadius: '16px',
  border: `1px solid ${
    theme.palette.mode === 'light'
      ? 'rgba(0, 0, 0, 0.12)'
      : 'rgba(255, 255, 255, 0.12)'
  }`,
  boxShadow: elevation > 0 ? theme.shadows[elevation] : 'none',
  transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
  overflow: 'hidden',
  padding: '24px',

  // Clickable card styling
  ...(clickable && {
    cursor: 'pointer',
    '&:hover': {
      transform: 'translateY(-4px)',
      boxShadow: theme.shadows[elevation + 2],
    },
  }),
}));

// Card component
const Card = ({
  children,
  clickable = false,
  elevation = 1,
  ...props
}) => {
  return (
    <StyledCard clickable={clickable} elevation={elevation} {...props}>
      {children}
    </StyledCard>
  );
};

Card.propTypes = {
  /**
   * The content of the card.
   */
  children: PropTypes.node,
  /**
   * If true, the card will have a hover effect.
   */
  clickable: PropTypes.bool,
  /**
   * Shadow depth, corresponds to `dp` in the spec.
   * It accepts values between 0 and 24 inclusive.
   */
  elevation: PropTypes.number,
  /**
   * Custom padding for card content.
   */
  padding: PropTypes.string,
};

export default Card;
